<template>
  <Modal
    v-model:visible="visible"
    :transparent="transparent"
    :transparent-external="transparentExternal"
    :external-background-color="externalBackgroundColor"
    :loading="loading"
    :width="width"
    :close-on-external-click="closeOnExternalClick"
    :full-screen="fullScreen"
    :pseudo-full-screen="pseudoFullScreen"
    :max-height-content="maxHeightContent"
  >
    <template #header v-if="$slots['header-' + currentPage] || headerProps">
      <MPHDefault
        v-if="headerProps"
        v-bind="headerProps"
        :progression="currentPage + 1"
        :maxProgression="nbPages"
        @close="$emit('close')"
      />
      <slot
        v-else-if="$slots['header-' + currentPage]"
        :name="'header-' + currentPage"
      ></slot>
    </template>

    <template #content>
      <slot :name="'content-' + currentPage"></slot>
    </template>

    <template #footer>
      <template v-if="displayNavigation && !$slots['footer-' + currentPage]">
        <v-row class="ma-2">
          <v-col class="pa-0">
            <v-row class="ma-0">
              <CustomButton
                :level="$enums.ButtonLevels.Secondary"
                :text="currentPage > 0 ? 'Previous' : 'Cancel'"
                class="mr-2"
                @click="goToPreviousPage"
              />
              <CustomButton
                v-if="currentPage < nbPages - 1"
                class="ml-auto"
                :level="$enums.ButtonLevels.Primary"
                :text="'Next'"
                @click="goToNextPage"
              />
            </v-row>
          </v-col>
        </v-row>
      </template>
      <template v-else-if="$slots['footer-' + currentPage]">
        <slot :name="'footer-' + currentPage"></slot>
      </template>
    </template>
  </Modal>
</template>

<script lang="ts">
import { Vue, Options, prop } from "vue-class-component";
import Modal from "@/components/UIElements/Modal.vue";
import CustomButton from "@/components/UIElements/CustomButton.vue";
import MPHDefault from "@/components/Modals/Partials/Headers/MPHDefault.vue";

class Props {
  // Tunnel properties
  startingPage?: number = prop({
    required: false,
  });
  nbPages: number = prop({
    required: true,
  });
  displayNavigation?: boolean = prop({
    required: false,
  });
  headerProps?: { [key: string]: any } = prop({
    required: false,
  });
  // Modal properties
  visible?: boolean = prop({
    required: false,
  });
  transparent?: boolean = prop({
    required: false,
  });
  transparentExternal?: boolean = prop({
    required: false,
  });
  externalBackgroundColor?: string = prop({
    required: false,
  });
  loading?: boolean = prop({
    required: false,
  });
  width?: string = prop({
    required: false,
  });
  closeOnExternalClick?: boolean = prop({
    required: false,
  });
  fullScreen?: boolean = prop({
    required: false,
  });
  pseudoFullScreen?: boolean = prop({
    required: false,
  });
  maxHeightContent?: string = prop({
    required: false,
  });
}

@Options({
  components: {
    Modal,
    CustomButton,
    MPHDefault,
  },
})
export default class ModalTunnel extends Vue.with(Props) {
  currentPage = 0;

  mounted(): void {
    this.currentPage = this.startingPage || 0;
  }

  goToPage(numPage: number): void {
    this.currentPage = numPage;
  }

  goToNextPage(): void {
    if (this.currentPage < this.nbPages - 1) {
      this.currentPage++;
    }
  }

  goToPreviousPage(): void {
    if (this.currentPage > 0) {
      this.currentPage--;
    } else {
      this.$emit("update:visible", false);
    }
  }

  get currentPageSlotName(): string {
    return "page-" + this.currentPage;
  }
}
</script>

<style lang="scss" scoped>
@import "@/css/variables";
</style>
